import * as React from 'react';
import { userOptions } from '../../endpoints';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { ApiToUse, SimpleFormComponentProps, SerializeType } from 'app/infrastructure/simple-form/types';
import { sfNames } from 'app/components/access-panel/sf-names';
import { ComplexValue } from 'app/types-shared';
import { TabsPanel } from 'app/components/tabs-panel';
import styles from './panel-role-access.scss';
import { AdminPaperSubPanel } from 'app/area/administration/edit/components';

interface RoleAccessComponentProps {
  translation: any;
  initialValue: ComplexValue<number>;
  formValue: ComplexValue<number>;
  roleBasedId: number;
  fetchingRoleBasedData: boolean;
  readOnly: boolean;
  loadRole: (id: number) => void;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  clearValueInStore: (id: string) => void;
}

const getValue = (formValue: ComplexValue<number>) => formValue && formValue.value || undefined;

export class RoleAccess extends React.PureComponent<RoleAccessComponentProps> {

  public componentDidMount() {
    const accessRole = this.props.initialValue?.value || getValue(this.props.formValue);
    this.props.loadRole(accessRole);
  }

  public componentDidUpdate() {
    const formValue = getValue(this.props.formValue);

    if (!this.props.fetchingRoleBasedData && this.props.roleBasedId !== formValue) {
      this.props.loadRole(formValue);
    }
  }

  private removeAll = (e?: any) => {
    e && e.preventDefault();
    this.props.clearValueInStore(sfNames.accessRole);
  };

  public render() {
    const {
      translation,
      readOnly,
      initialValue,
      formValue,
      formComponent: SimpleForm
    } = this.props;

    return <AdminPaperSubPanel title={translation.authorisation}>
      {(!readOnly || (initialValue && initialValue.value) ? <div className={styles.highlightedBox}>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <SimpleForm
              name={sfNames.accessRole}
              type={FIELD_TYPE.SELECT_SINGLE}
              optionsEndpoint={userOptions.role}
              placeholder={translation.search}
              apiToUse={ApiToUse.ADMINAPI}
              translation={translation}
              label={{ text: translation.access_base_on_role }}
              initialValue={initialValue}
              serialize={{ type: SerializeType.V_VALUE }}
              readOnly={readOnly}
            />
          </div>
          {!readOnly && formValue && formValue.value > 0 && <div className={`${styles.link} col-lg-6 col-sm-12`}>
            <a href="#" className="standalone-link" onClick={this.removeAll}>
              {translation.remove_all_role_based_access}
            </a>
          </div>}
        </div>
      </div>
        : (initialValue && initialValue.value ? <TabsPanel>
          <p className="no-content">
            {initialValue.description}
          </p>
        </TabsPanel> : <p className="no-content">
          {translation.no_role_assigned}
        </p>))}
    </AdminPaperSubPanel>;
  }
}
